module.exports = __webpack_public_path__ + "static/media/retirement-object-3-2-2.5d9e75e3.svg";